
<form class="mce-form-section">

    <div class="mce-form-field-group">

        <div>
            <mat-checkbox [formField]="form().addRCD">Add RCD</mat-checkbox>
        </div>


        @if (form().addRCD().value()) {
        <div [class.mce-form-field-disabled]="ratingsRx.isLoading()">
            <mat-form-field class="w-full">
                <mat-label>rcd rating</mat-label>
                <mat-select [formField]="form().rating">
                    @for (option of ratings(); track option.i) {
                    <mat-option [value]="option.i">{{(option.i ?? 0) * 1e3}} mA</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        }

    </div>



</form>



